module.exports = __webpack_public_path__ + "static/media/background.ec7a05b8.svg";